var map = {
	"./decidim/avatar-multiuser.png": 41522,
	"./decidim/brands/facebook.svg": 13860,
	"./decidim/brands/google.svg": 22525,
	"./decidim/brands/twitter-x.svg": 16462,
	"./decidim/cc-badge.png": 65772,
	"./decidim/decidim-logo.svg": 13376,
	"./decidim/default-avatar.svg": 88504,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8100,
	"./decidim/icons.svg": 62419,
	"./decidim/pattern.png": 43332,
	"./decidim/placeholder-card-g.svg": 86545,
	"./decidim/placeholder-card-l.svg": 59962,
	"./decidim/placeholder.jpg": 89097,
	"./decidim/remixicon.symbol.svg": 37565,
	"./decidim/vendor/social-share-button/douban.svg": 28876,
	"./decidim/vendor/social-share-button/email.svg": 21673,
	"./decidim/vendor/social-share-button/facebook.svg": 22303,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 12481,
	"./decidim/vendor/social-share-button/hacker_news.svg": 10057,
	"./decidim/vendor/social-share-button/linkedin.svg": 43593,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 74602,
	"./decidim/vendor/social-share-button/pinterest.svg": 25935,
	"./decidim/vendor/social-share-button/reddit.svg": 81843,
	"./decidim/vendor/social-share-button/telegram.svg": 33958,
	"./decidim/vendor/social-share-button/tumblr.svg": 76869,
	"./decidim/vendor/social-share-button/twitter.svg": 2680,
	"./decidim/vendor/social-share-button/vkontakte.svg": 17558,
	"./decidim/vendor/social-share-button/wechat.svg": 66193,
	"./decidim/vendor/social-share-button/whatsapp.svg": 99673,
	"./decidim/vendor/social-share-button/x.svg": 25297,
	"./decidim/vendor/social-share-button/xing.svg": 64255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56653;